import React, { useState, useEffect } from 'react';
import { Select, Typography, Space, Grid } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRealmContext } from '../contexts/RealmProvider';
import { usePackageContext } from '../contexts/PackageProvider'; // Import the PackageContext
import { CheckCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'; // Importing the required icons
import './css/InputField.css'; // Ensure the path is correct
import './css/realmInput.css'; // Ensure the path is correct
import { Button } from 'antd';
import EditRealmModal from './EditRealmModal'; // Path as needed
import {useRealmObjectContext} from '../contexts/RealmObjectProvider'; // Import the function to set realmObjectID
import { useCampaignContext } from '../contexts/CampaignProvider'; // Import the CampaignContext
import { ReactComponent as RealmIcon } from '../assets/realm_icon.svg';
//realm_icon.svg";


const { Option } = Select;
const { Title, Text } = Typography;

const RealmInput = ({transform}) => {
  const { realmID, setRealmID } = useRealmContext();
  const { setRealmObjectID } = useRealmObjectContext(); // Import the function to set realmObjectID
  const { getSortedItems } = usePackageContext(); // Get the sorted items function from PackageContext
  const [inputValue, setInputValue] = useState(realmID);
  const navigate = useNavigate();
  const location = useLocation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const showAlways = (transform === 'no') ? true : false
  const [editVisible, setEditVisible] = useState(false);
  const { selectCampaign } = useCampaignContext();
  
  // Fetch the sorted list of realm items on component mount
  const realmItems = getSortedItems('realm', 'name', 'asc');

  useEffect(() => {
    // Sync inputValue with realmID on load
    setInputValue(realmID);
  }, [realmID]);

  const handleSelectChange = (value) => {
    setInputValue(value);
    if (realmID !== value) {
      setRealmID(value);
      setRealmObjectID(null);
      selectCampaign(null); // Reset selected campaign when realm changes
      updateURL(value);
    }
  };

  const updateURL = (newRealmID) => {
    const params = new URLSearchParams(location.search);
    params.set('realmID', newRealmID);
    navigate({ search: params.toString() }, { replace: true });
  };

  const renderIcon = () => {
    return realmID ? <CheckCircleOutlined /> : <PlusCircleOutlined />;
  };

  return (
    <>
      {/* FLEX ROW — everything lives in one line */}
      <div className="realm-input-container">
        {/* Label */}
        <Title level={4} className="header-title">
          Realm
        </Title>

        {/* Selector OR text */}
        {realmItems.length > 1 ? (
         <>
            <Select
              className="small-select"
              popupClassName="small-select"
              value={inputValue}
              onChange={handleSelectChange}
            >
              {realmItems.map((item) => (
                <Option key={item.name} value={item.name}>
                  {item.name}
                </Option>
              ))}
            </Select>
            {/* Edit button */}
              <Button
              type="link"
              className="edit-realm-button"
              style={{ color: 'var(--title-text-light)' }}
              icon={<RealmIcon style={{ width: 24, height: 24 }} />}
              onClick={() => setEditVisible(true)}
            />
          </>
        ) : (
          <>
              <Text className="single-realm-text realm-label">
                {realmItems[0]?.name || 'No Realms Available'}
              </Text>
              <Button
              type="link"
              className="edit-realm-button-no-selector"
              style={{ color: 'var(--title-text-light)' }}
              icon={<RealmIcon style={{ width: 24, height: 24 }} />}
              onClick={() => setEditVisible(true)}
            />
          </>
        )}       
      </div>

      {/* modal lives outside the flex row */}
      <EditRealmModal
        visible={editVisible}
        onClose={() => setEditVisible(false)}
        realmTypes={['fantasy','sci-fi','Super Hero','historical','other']}
      />
    </>
  );
};

export default RealmInput;
